import React, { useEffect , useState } from 'react'
import { Link } from 'react-router-dom'

const ContentBar = () => {
 
 
          const [latest,setLatest] = useState(null)
          const [loading,setLoading] = useState(true)
          const [error,setError] = useState(null)

    
    useEffect(() => {
         
          
         const fetchData = async () => {
      try {
        const res = await fetch("https://teluguone.com/photos_api/photosLatestJson?start=0&limit=7");
        if (!res.ok) throw new Error(`API Response Was Not Ok`)
        const data = await res.json();
        setLatest(data.photosHomeByType || '');
      
      } catch (e) {
        console.error("Fetch error:", e);
        setError(e.message)
      }finally {
         setLoading(false)
      }
    };

    fetchData();
         

    },[])  
    
    
  


    if (loading) {
        return <div className="ticker-bar">
             <span className="ticker-label">LATEST</span>
              <div className="ticker-track">
              </div>
        </div>
    }
    if (error) {
        return null;
    }




   
    return (
     
       <div className="ticker-bar">
            <span className="ticker-label">LATEST</span>
         <div className="ticker-track">
            <span> 
                {latest && latest.map((item,index) => <Link key={index} to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )} >#{item.title ? item.title : ''}</Link> ) }
            </span>
         </div>
        </div>
  )


}

export default ContentBar
